import { createAction, handleActions } from "redux-actions";
import { Map } from "immutable";
// import searchResult from "../../components/map/modal/searchResult";

const SET_SEARCH = "SET_SEARCH";
const SET_PRINT = "SET_PRINT";
const SET_MODAL = "SET_MODAL";

export const setSearch = createAction(SET_SEARCH);
export const setPrint = createAction(SET_PRINT);
export const setModal = createAction(SET_MODAL);

const initialState = Map({
	searchResult: "", // 검색결과 엘리먼트
	mapPrint: "", // 지도 프린트

	realEstateModal: null, // 실거래가 모달
	weatherDetailModal: null, // 관광 -> 상세기상정보 모달
	shipModal: null, // 교통 -> 해상 모달
	flightModal: null, // 교통 -> 항공 모달
	trainModal: null, // 교통 -> KTX/열차 모달
	busModal: null, // 교통 -> 버스 모달
	workInfoModal:null,
});

export default handleActions(
	{
		[SET_SEARCH]: (state, action) => {
			return state.set("searchResult", action.payload);
		},
		[SET_PRINT]: (state, action) => {
			return state.set("mapPrint", action.payload);
		},
		[SET_MODAL]: (state, action) => {
			// console.log({
			// 	target: 'Redux',
			// 	action
			// });
			return state.set(action.payload.id, action.payload.target);
		},
	},
	initialState
);
